export const JUMBOTRON = {
  colors: {
    // react: '#61DAFB',
    // wordpress: '#00165A',
    // ecommerce: '#674399',
    // graphics: '#BE2C29',
    // application: '#075B9A',
    react: 'linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(13,6,39,1) 35%, rgba(72,206,247,1) 100%)',
    wordpress: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(0,22,90,1) 35%, rgba(86,142,255,1) 100%)',
    ecommerce: 'linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(103,67,153,1) 45%, rgba(131,83,198,1) 100%)',
    graphics: 'linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(162,17,14,1) 45%, rgba(235,89,86,1) 100%)',
    // application: 'linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(7,91,154,1) 45%, rgba(22,120,194,1) 100%)',
    application: 'linear-gradient(90deg, rgba(22,120,194,1) 0%, rgba(7,91,154,1) 45%, rgba(0,0,0,1)  100%)',
    seo: 'linear-gradient(90deg, rgba(120,144,235,1) 0%, rgba(73,100,201,1) 45%, rgba(0,0,0,1) 100%)'
  },
  home: [
    {
      line1: 'We create',
      line2: 'Scalable',
      line3: 'Web Applications',
      display: true,
    },
    {
      line1: 'We do',
      line2: 'Beautiful',
      line3: 'Web Design',
      display: false,
    },
    {
      line1: 'We create',
      line2: 'Stunning',
      line3: 'Graphics and Logos',
      display: false,
    },
    {
      line1: 'We do',
      line2: 'Flexible',
      line3: 'E-Commerce Websites',
      display: false,
    },
  ],
  react: [
    {
      line1: 'We create',
      line2: 'Scalable',
      line3: 'React Applications',
      display: true,
    },
    {
      line1: 'We do',
      line2: 'Beautiful',
      line3: 'React Applications',
      display: false,
    },
    {
      line1: 'We create',
      line2: 'Stunning',
      line3: 'React Applications',
      display: false,
    },
    {
      line1: 'We do',
      line2: 'Flexible',
      line3: 'React Websites',
      display: false,
    },
  ],
  wordpress: [
    {
      line1: 'We create',
      line2: 'Scalable',
      line3: 'Wordpress Websites',
      display: true,
    },
    {
      line1: 'We do',
      line2: 'Beautiful',
      line3: 'Wordpress Experience',
      display: false,
    },
    {
      line1: 'We create',
      line2: 'Stunning',
      line3: 'Wordpress Sites',
      display: false,
    },
    {
      line1: 'We do',
      line2: 'Flexible',
      line3: 'Wordpress Apps',
      display: false,
    },
  ],
  ecommerce: [
    {
      line1: 'We create',
      line2: 'Scalable',
      line3: 'Ecommerce Websites',
      display: true,
    },
    {
      line1: 'We deliver',
      line2: 'Great',
      line3: 'Ecommerce Experience',
      display: false,
    },
    {
      line1: 'We create',
      line2: 'Stunning',
      line3: 'Ecommerce Sites',
      display: false,
    },
    {
      line1: 'We do',
      line2: 'Flexible',
      line3: 'Ecommerce Websites',
      display: false,
    },
  ],
  graphics: [
    {
      line1: 'We create',
      line2: 'Scalable',
      line3: 'UI/UI Design',
      display: true,
    },
    {
      line1: 'We deliver',
      line2: 'Beautiful',
      line3: 'UI and LOGOS',
      display: false,
    },
    {
      line1: 'We create',
      line2: 'Stunning',
      line3: 'UI/UX Layouts',
      display: false,
    },
    {
      line1: 'We do',
      line2: 'Responsive',
      line3: 'UI Design',
      display: false,
    },
  ],
  application: [
    {
      line1: 'We create',
      line2: 'Scalable',
      line3: 'Smartphone Apps',
      display: true,
    },
    {
      line1: 'We deliver',
      line2: 'Fast',
      line3: 'Smartphone Apps',
      display: false,
    },
    {
      line1: 'We do',
      line2: 'React & Flutter',
      line3: 'Smartphone Apps',
      display: false,
    },
    {
      line1: 'We do',
      line2: 'Flexible',
      line3: 'IOS and Android Apps',
      display: false,
    },
  ],
  seo: [
    {
      line1: 'We improve',
      line2: 'Discoverablity',
      line3: 'of Websites on Google',
      display: true,
    },
    {
      line1: 'We deliver',
      line2: 'Fast',
      line3: 'Page loading Optimizations',
      display: false,
    },
  ],
};